import React, { useState, useRef } from "react";
import { useNavigate, Link } from 'react-router-dom';
import '../assets/css/login.css';
import API from '../api/axios';
import jbAPI from '../api/jobboard';
import sendOtp from '../helpers/sendEmailOtp';
import { validateEmail, validateMobile, validateCompany } from "../api/validationAPI";

const APP_ID = process.env.REACT_APP_APP_ID;
const Signup = () => {
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [userId, setUserId] = useState(null);
  const [appUserId, setAppUserId] = useState(null);
  const [message, setMessage] = useState({ type: "", text: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    userType: "",
    mobileNumber: "",
    otp: "",
    fullName: "",
    email: "",
    password: "",
    companyName: "",
    numOfEmp: "",
    designation: "",
    pinCode: "",
    cAddress: "",
    secretQuestion: "",
    secretAnswer: "",
  });

  // Handle Input Change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };


  
  // Move to next step
  
  const nextStep = () => {
    if (formData.userType === "jobSeeker" && step === 2) {
      setStep(step + 2); // Skip step 3
      
    } else {
      setStep(step + 1);
    }
    console.log("STEP : ",step);
    // if(step !== 4) {
    //   setMessage({ type: "", text: "" });
    // }
    
  };
    // Move to previous step
  const prevStep = () => {
    if (formData.userType === "jobSeeker" && step === 4) {
      setStep(step - 2); // Skip step 3
    } else {
      setStep(step - 1);
    }
    setMessage({ type: "", text: "" });
  };
  

  

  // Handles Step 2, 3, and 4 logic
  const handleNextStep = async (e) => {
    e.preventDefault(); // Necessary to prevent page reload
    setLoading(true);

    try {
      if (step === 2) {
        const response = await API.post("/addUser", {
          auth_user_phone_number: formData.mobileNumber,
          user_email: formData.email,
          auth_fullname: formData.fullName,
          auth_user_password_hash: formData.password,
          auth_userRole: "user",
          secretQuestion: formData.secretQuestion,
          secretAnswer: formData.secretAnswer
        });

        if (response.data && response.data.success) {
          const userId = response.data.userId;
          setUserId(userId);

          const assignAppResponse = await API.post("/assignUserToApp", {
            user_id: userId,
            app_id: APP_ID,
            role: formData.userType,
          });

          if (assignAppResponse.data && assignAppResponse.data.success) {
            clearMessage(); // ✅ hides error
            setAppUserId(assignAppResponse.data.appUserID);
            if (formData.userType === "jobSeeker") {
             
              await sendOtp(formData, nextStep, setMessage); // Calls OTP and moves to step 4
              await jbAPI.post("/addCandidate", {
                seeker_id: assignAppResponse.data.appUserID,
                user_id: userId,
                full_name: formData.fullName,
                phone_number: formData.mobileNumber,
                email: formData.email,
              });
              nextStep();
            } else {
              nextStep();
            }
          } else {            
            setMessage({ type: "danger", text: response.data.message || "Candidate insertion failed" });
          }
        } else {          
          setMessage({ type: "danger", text: response.data.message || "Failed to register user" });

        }

      } else if (step === 3) {
        if(formData.userType === "employer"){
          const addCompanyResponse = await jbAPI.post("/addCompany", {
            user_id: userId,
            company_name: formData.companyName,
            num_of_employees: formData.numOfEmp,
            designation: formData.designation,
            pin_code: formData.pinCode,
            address: formData.cAddress,
          });
  
          if (addCompanyResponse.data && addCompanyResponse.data.success) {
            clearMessage(); // ✅ hides error
            await jbAPI.post("/assignEmpToComp", {
              employer_id:appUserId,
              user_id: userId,
              company_id: addCompanyResponse.data.companyId,
              designation: formData.designation,
              phone_number: formData.mobileNumber,
              email: formData.email,
            });
  
            nextStep(); 
          } else {
            setMessage({ type: "danger", text: "Failed to add company" });
          }
        }
        
        await sendOtp(formData, nextStep, setMessage);
      } else if (step === 4) {
        console.log("Step 4");
        
      }
    } catch (err) {
      setMessage({ type: "danger", text: "User already exists with this email or mobile number." });
    } finally {
      setLoading(false);
    }
  };
  const verifyOtp = async () => {
    setLoading(true);
    try {
      const response = await API.post("/verify-otp", {
        email: formData.email,
        otp: formData.otp,
      });

      if (response.data) {
        await API.patch(`/updateEmailOtpStatus/${userId}`);
        // alert("OTP Verified!");
        setMessage({ type: "info", text: "OTP Verified!" });
        console.log("Current step before nextStep:", step);
        nextStep();
        setTimeout(() => {
          console.log("Step after nextStep:", step);
        }, 100);

      } else {
        // alert("Invalid OTP");
        setMessage({ type: "warning", text: "Invalid OTP" });
      }
    } catch (error) {
      // alert("Error verifying OTP");
      setMessage({ type: "danger", text: "Error verifying OTP." });
    } finally {
      setLoading(false);
    }
  };
  const [formError, setFormError] = useState("");
  const [email, setEmail] = useState("");
  const [emailExists, setEmailExists] = useState(false);

  const handleEmailChange = async (e) => {
    const value = e.target.value;
    setEmail(value);

    // optional: basic frontend format check
    if (!value || !value.includes("@")) {
      setEmailExists(false);
      return;
    }

    const result = await validateEmail(value);
    setEmailExists(result.exists);
  };

  const mobileDebounceRef = useRef(null);
  const [mobileExists, setMobileExists] = useState(false);

  const handleMobileChange = (e) => {
    let value = e.target.value;

   // remove non-digits
    value = value.replace(/\D/g, "");

    e.target.value = value; // force corrected value

    if (mobileDebounceRef.current) {
      clearTimeout(mobileDebounceRef.current);
    }

    mobileDebounceRef.current = setTimeout(async () => {
      // basic frontend check (India example)
      if (value.length !== 10) {
        setMobileExists(false);
        return;
      }

      const result = await validateMobile(value);
      setMobileExists(result.exists);
    }, 500);
  };

  const [companyExists, setCompanyExists] = useState(false);

  const handleCompanyChange = async (e) => {
    const value = e.target.value;
    setCompanyExists(value);

    // optional: basic frontend format check
    if (!value) {
      setCompanyExists(false);
      return;
    }

    const result = await validateCompany(value);
    setCompanyExists(result.exists);
  };
  const validateBeforeNext = async () => {
    setFormError("");

    // basic required checks
    if (!formData.email || !formData.mobileNumber) {
      setFormError("Email and Mobile Number are required");
      return false;
    }

    // call APIs again (authoritative check)
    const [emailRes, mobileRes] = await Promise.all([
      validateEmail(formData.email),
      validateMobile(formData.mobileNumber),
    ]);

    setEmailExists(emailRes.exists);
    setMobileExists(mobileRes.exists);

    if (emailRes.exists) {
      setFormError("Email already exists");
      return false;
    }

    if (mobileRes.exists) {
      setFormError("Mobile number already exists");
      return false;
    }

    return true;
  };

  const handleNextClick = async () => {
    const isValid = await validateBeforeNext();

    if (!isValid) return;

    // ✅ proceed to next step
    nextStep(); 
  };

  const clearMessage = () => {
    setMessage({ type: "", text: "" });
  };

  return (
    <div className="login-form-bg h-100">
      <div className="container h-100">
        <div className="row justify-content-center h-100">
          <div className="col-xl-6">
            <div className="form-input-content">
              <div className="card login-card login-form mb-0">
                <div className="card-body pt-5">
                  {/* <a className="text-center" href="index.html">
                    <h4>Savitar</h4>
                  </a> */}
                  <img src="/assets/img/logo-preview.png" alt="Logo"
                                  className='d-block mx-auto'
                                  style={{
                                    backgroundColor: 'transparent', // or match the parent background
                                    mixBlendMode: 'multiply' // optional: blends black out on light background
                                  }}/>
                  {step !== 5 && message.text && (
                      <div className={`alert alert-${message.type} mt-3`} role="alert">
                        {message.text}
                      </div>
                   
                  )}
                  

                  {/* Step 1: User Details and Send OTP */}
                  {/* Step 1: Choose User Type */}
                  {step === 1 && (
                    <form className="mt-5 mb-5 login-input" onSubmit={(e) => { e.preventDefault(); nextStep(); }}>
                      <div className="form-group">
                        <label className="card-title">You are Signing Up for: <span className="text-danger">*&nbsp;</span></label>
                        <label className="radio-inline mr-3 card-title">
                          <input type="radio" name="userType" value="employer" onChange={handleChange} required /> &nbsp;Employer
                        </label>
                        <label className="radio-inline mr-3 card-title">
                          <input type="radio" name="userType" value="jobSeeker" onChange={handleChange} required/> &nbsp;Job Seeker
                        </label>
                      </div>
                      <button type="submit" className="btn login-form__btn submit w-100">Next</button>
                    </form>
                  )}

                  {/* Step 2: Basic Info */}
                  {step === 2 && (
                    <form className="mt-5 mb-5 login-input" onSubmit={handleNextStep}>
                      <div className="form-group">
                        <label className="card-title">Full Name <span className="text-danger">*</span></label>
                        <input type="text" name="fullName" className="form-control" placeholder="Full Name" value={formData.fullName} onChange={handleChange} required />
                      </div>
                      <div className="form-group">
                        <label className="card-title">Mobile Number<span className="text-danger">*</span></label>
                        <input type="text" name="mobileNumber" className="form-control" placeholder="Mobile Number" value={formData.mobileNumber}
                          onChange={(e) => {
                          handleChange(e);        // updates formData
                          handleMobileChange(e);   // calls validation API
                        }}
                        onKeyDown={(e) => {
                        if (
                          !/[0-9]/.test(e.key) &&
                          e.key !== "Backspace" &&
                          e.key !== "Delete" &&
                          e.key !== "ArrowLeft" &&
                          e.key !== "ArrowRight" &&
                          e.key !== "Tab"
                        ) {
                          e.preventDefault();
                        }
                      }}
                        maxLength={10}
                         required />
                        {mobileExists && (
                          <span style={{ color: "red" }}>
                            Mobile number already exists
                          </span>
                        )}
                      </div>
                      <div className="form-group">
                        <label className="card-title">{formData.userType === 'employer' ? 'Company Email ID' : 'Email ID'}<span className="text-danger">*</span></label>
                        <input type="email" name="email" className="form-control" placeholder="Email" value={formData.email} 
                        onChange={(e) => {
                          handleChange(e);        // updates formData
                          handleEmailChange(e);   // calls validation API
                        }}
                        required />
                        {emailExists && (
                            <span style={{ color: "red" }}>
                              Email already exists
                            </span>
                          )}
                      </div>
                      <div className="input-group">
                        
                        <input type={showPassword ? "text" : "password"} name="password" className="form-control" placeholder="Password" value={formData.password} onChange={handleChange} required />
                        <span
                        className="input-group-text"
                        onClick={() => setShowPassword(!showPassword)}
                        style={{ cursor: "pointer" }}
                      >
                       <i
                          className={`fa fa-solid ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
                        />

                      </span>
                      </div>
                      <br/>
                      <div className="form-group">
                        <label className="card-title">Secret Question <span className="text-danger">*</span></label>
                        <input type="text" name="secretQuestion" className="form-control" placeholder="Enter a secret question" value={formData.secretQuestion} onChange={handleChange} required />
                      </div>
                      <div className="form-group">
                        <label className="card-title">Secret Answer <span className="text-danger">*</span></label>
                        <input type="text" name="secretAnswer" className="form-control" placeholder="Enter the answer" value={formData.secretAnswer} onChange={handleChange} required />
                      </div>
                      <button type="button" onClick={prevStep} className="btn btn-secondary mt-3">Back</button>
                      <button type="submit" className="btn btn-primary mt-3" onClick={handleNextClick} disabled={loading || emailExists || mobileExists}>
                        {loading ? "Registering..." : (formData.userType === 'employer') ? "Next" : "Register & Send OTP"}
                      </button>
                    </form>
                  )}

                  {/* Step 3: Company Details (Only if Employer) */}
                  {step === 3 && formData.userType === 'employer' && (
                    <form className="mt-5 mb-5 login-input" onSubmit={handleNextStep}>
                      <div className="form-group">
                        <label className="card-title">Company Name <span className="text-danger">*</span></label>
                        <input type="text" name="companyName" className="form-control" placeholder="Enter Company Name" 
                          value={formData.companyName} 
                           onChange={(e) => {
                          handleChange(e);        // updates formData
                          handleCompanyChange(e);   // calls validation API
                          }} 
                          required />
                          {companyExists && (
                            <span style={{ color: "red" }}>
                              Company already exists
                            </span>
                          )}
                      </div>
                      <div className="form-group">
                        <label className="card-title">Number of Employees <span className="text-danger">*</span></label>
                        <input type="text" name="numOfEmp" className="form-control" placeholder="Number of Employees" value={formData.numOfEmp} onChange={handleChange} required />
                      </div>
                      <div className="form-group">
                        <label className="card-title">Designation <span className="text-danger">*</span></label>
                        <input type="text" name="designation" className="form-control" placeholder="Enter Designation" value={formData.designation} onChange={handleChange} required />
                      </div>
                      <div className="form-group">
                        <label className="card-title">Pincode <span className="text-danger">*</span></label>
                        <input type="text" name="pinCode" className="form-control" placeholder="Enter Pincode" value={formData.pinCode} onChange={handleChange} required />
                      </div>
                      <div className="form-group">
                        <label className="card-title">Company Address <span className="text-danger">*</span></label>
                        <input type="text" name="cAddress" className="form-control" placeholder="Enter Address" value={formData.cAddress} onChange={handleChange} required />
                      </div>
                      <button type="button" onClick={prevStep} className="btn btn-secondary mt-3">Back</button>
                      <button type="submit" className="btn btn-primary mt-3" disabled={loading || companyExists}>
                        {loading ? "Registering..." : "Register & Send OTP"}
                      </button>
                    </form>
                  )}

                  {/* Step 4: OTP Verification */}
                  {step === 4 && (
                    <form className="mt-5 mb-5 login-input" onSubmit={(e) => { e.preventDefault(); verifyOtp(); }}>
                      <div>
                        <h5>Enter OTP that has been sent to your registered Email ID.</h5>
                        <input
                          type="text"
                          name="otp"
                          className="form-control"
                          placeholder="Enter OTP"
                          value={formData.otp}
                          onChange={handleChange}
                          required
                        />
                        {/* <button className="btn btn-secondary mt-3" onClick={prevStep}>Back</button> */}
                        <button className="btn btn-primary mt-3" disabled={loading}>
                          {loading ? "Sending OTP..." : "Verify OTP"}
                        </button>
                      </div>
                    </form>
                  )}

                  {/* Step 5: Success Message */}
                  {step === 5 && (
                    
                    <div className="mt-5 text-center">
                      <h2>🎉 Signup Successful!</h2>
                      <p>Your account has been created and verified successfully.</p>
                      <button onClick={() => navigate('/')} className="btn btn-primary">Go to Login</button>
                    </div>
                  )}


                  {/* Redirect to Login */}
                  {(
                    <>
                      <p className="mt-5 login-form__footer">
                        Already have an account? <Link to="/" className="text-primary">Sign In</Link> now
                      </p>
                      <p className="mt-2 login-form__footer">
                        <Link to="/forgot-password" className="text-primary">
                          Forgot Password?
                        </Link>
                      </p>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signup;
